export class PickupCorporateScheduleConfigEndpoint {
  public loadConfig(clientId?: number): string {
    const query = clientId
      ? `?single=true&client_id=${clientId}`
      : "?single=true";
    return `/horde/v1/client/pickup-schedule${query}`;
  }

  public createConfig(): string {
    return "/horde/v1/client/pickup-schedule";
  }

  public updateConfig(id: number): string {
    return `/horde/v1/client/pickup-schedule/${id}`;
  }
}
